import script from "./TestimonialsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsBlock.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsBlock.vue?vue&type=style&index=0&id=4bb0942f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb0942f"]])

export default __exports__